// extracted by mini-css-extract-plugin
export default {"drinkCardPage":"DrinkCard_drinkCardPage__gOJfs"};